export const SET_CHECKOUT_MEAL_PLAN = 'SET_CHECKOUT_MEAL_PLAN';
export const UPDATE_CHECKOUT_MEAL_PLAN = 'UPDATE_CHECKOUT_MEAL_PLAN';
export const CLEAR_CHECKOUT_MEAL_PLAN = 'CLEAR_CHECKOUT_MEAL_PLAN';
export const CHECKOUT_DELETE_MEAL_PLAN = 'CHECKOUT_DELETE_MEAL_PLAN';

const initialState = {};

export function setCheckoutMealPlan(obj) {
  return {
    type    : SET_CHECKOUT_MEAL_PLAN,
    payload : obj
  };
}

export function updateCheckoutMealPlan(date, obj) {
  return {
    type    : UPDATE_CHECKOUT_MEAL_PLAN,
    payload : { date, obj }
  };
}
export function deleteCheckoutMealPlan(date) {
  return {
    type    : CHECKOUT_DELETE_MEAL_PLAN,
    payload : { date }
  };
}

export function clearCheckoutMealPlan() {
  return {
    type    : CLEAR_CHECKOUT_MEAL_PLAN
  };
}

export default function checkoutMealPlanReducer(state = initialState, action) {
 
  if (action.type === SET_CHECKOUT_MEAL_PLAN) {
    return (action.payload==undefined)?null:action.payload;
  } 
  if (action.type === UPDATE_CHECKOUT_MEAL_PLAN) {
        const { date, obj } = action.payload;
        return { ...state, [date]: obj };
  }
  if(action.type === CHECKOUT_DELETE_MEAL_PLAN) {
    const { date } = action.payload;
    const filtered = Object.keys(state)
         .filter(key => date!=key)
         .reduce((obj, key) => {
           obj[key] = state[key];
           return obj;
         }, {});
    return { ...filtered };
 }
  if (action.type === CLEAR_CHECKOUT_MEAL_PLAN) {
    return initialState;
  }
  return state;
}
